// Reuse Shopify's native preferences UI. Never manage Shopify consent cookies here.
if (document.getElementById('CookiePolicyTitle')) document.title = 'Cookie Policy — PaZe Home & Care';
const cookiePreferenceButton = document.querySelector('[data-paze-cookie-preferences]');
if (cookiePreferenceButton) {
  const nativePreferences = () => window.privacyBanner?.showPreferences;
  const reveal = () => { if (typeof nativePreferences() === 'function') cookiePreferenceButton.hidden = false; };
  cookiePreferenceButton.addEventListener('click', () => window.privacyBanner.showPreferences());
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', reveal);
  window.addEventListener('load', reveal, {once:true});
  let attempts = 0;
  const ready = setInterval(() => { reveal(); if (!cookiePreferenceButton.hidden || ++attempts >= 100) clearInterval(ready); }, 100);
  reveal();
}
